import { FileData } from './file-data.model';
import { UserPermissionsInterface } from './user-permissions.model';

export enum ManagedUserFilterParamEnum {
  STATUSES = 'isActive',
}

export interface ManagedUsersListRowInterface {
  id: number;
  firstName: string | null;
  lastName: string | null;
  email: string;
  isActive: boolean;
  profilePicture: Pick<FileData, 'url'> | null;
  createdAt: string;
  lastSeen: string;
  isProfileComplete: boolean;
}

export interface ManagedUserInterface extends ManagedUsersListRowInterface {
  phone: string | null;
  permissions: UserPermissionsInterface;
}
